// navLinks.js — Header navigation configuration

const navLinks = [
  { id: 1, label: 'Home',       path: '/',      type: 'link'    },
   { id: 2, label: 'Properties', path: '/properties?kind=property', type: 'link' },
  { id: 3, label: 'Projects', path: '/properties?kind=project', type: 'link' },


  {
    id: 4,
    label: 'Pages',
    type: 'dropdown',
    children: [
      { id: 41, label: 'About Us',       path: '/about'          },
      { id: 42, label: 'Privacy Policy', path: '/privacy-policy' },
      { id: 43, label: 'Contact Us', path: '/contact' },
      { id: 44, label: 'Terms & Conditions', path: '/terms' },
    ],
  },
];

export default navLinks;